import { Tooltip } from "antd";
import styles from "./eventsMessage.module.scss";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatEventsInner from "../chatEventInner";
import React, { useEffect } from "react";
import moment from "moment";
import ChatRightInfo from "../chatRightInfo";
import ChatLeftInfo from "../chatLeftInfo";
import ChatLike from "../chatLike";
import { useSelector } from "react-redux";
import { chats, initialStateModel } from "../../../../models/model";

type eventMessageProps = {
  searchedData?: any;
  data: any;
  viewData?: any;
  savedData?: any;
  timeValue?:any;
};
export default function URChatEventsMessage({ data, searchedData, viewData, savedData,timeValue }: eventMessageProps) {
  let { direction, timestamp, fromcaller_details, id } = data;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let timeCount = timeValue !== undefined ? timeValue : 18;
  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
  }, [savedData]);

  try {
    let htimestamp = moment(timestamp).format("hh:mm A");
    let eventData: any = "";

    if (data?.message?.body) {
      eventData = data?.message?.body;
    }
    if (viewData && viewData.message?.messageType === "EVENTS") {
      viewData = data?.message?.body;
    }

    const handlehighlightHover = () => {
      var element: HTMLElement | any = document.getElementById(id) || null;
      if (element != null) {
        element.classList.add("highlighthover");
      }
    };

  return (
    <>
      {/* <div className={`${styles.chatMsg} ${styles.leftMessage} ${styles.addBookleftMessage}`}> */}
      {direction === 'IN'?<div className={`${chatReducer.isSaveChat&& id===savedData?'savedhighlight':''
          } lftMessage  ${styles.chatMsg} ${styles.leftMessage}`} id={id}>
        {timeCount > 15 &&<div className={`${styles.chatUserDetails}`}>
          <ChatUserInfo userDetails = {fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon leftSide'/>
          <div className={styles.convMemName}><span>{fromcaller_details===undefined?'Unknown User':fromcaller_details?.caller_id}</span></div>
        </div>}
        <div className={styles.chatLeftMessages}>
          <div className={styles.chatLeft}>
            <Tooltip title={htimestamp} className='cusTooltip' overlayClassName='customTooltip'>
              <div className={styles.chatTime}>{htimestamp}</div></Tooltip>
            <div className={`msgContentLft ${styles.chatContent}`}>
              
              <span className={id===savedData?"focusText":"" }  tabIndex={0}>
              <ChatEventsInner eventData={eventData} searchedData={searchedData} viewData={viewData}/></span>
              <span className={styles.eventsChatContent}>{fromcaller_details?.first_name} {data?.message?.isEdit ? " updated the Event" : " created a new Event"} </span>
              <ChatLeftInfo userDetails = {fromcaller_details} timeStamp = {timestamp} message={data}></ChatLeftInfo>
              <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover}/></div>
            </div>
          </div>
          </div> 
          <ChatLike className="likeLeft" placement="top" tooltipTitle={data?.likeduserdetails} message={data} />

          </div> 
         : (
         <div className={`${chatReducer.isSaveChat&& id === savedData?'savedhighlight':''
          } rtMessage ${styles.chatMsg} ${styles.rightMessage}`} id={id}>
       {timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
          <div className={styles.convMemName}><span>You</span></div>
          <ChatUserInfo userDetails = {fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon rightSide'/>
          {/* <URCheckBox className="chatSelectRight"/> */}
        </div>}
        <div className={styles.chatRightMessages}>
          <div className={styles.chatRight}>
            <div className={`msgContentRT ${styles.chatContent}`}>
              <span className={id===savedData?"focusText":"" }  tabIndex={0}>
                <ChatEventsInner eventData={eventData} searchedData={searchedData} viewData={viewData}/>
                
              </span>
              <span className={styles.eventsChatContent}>
                  {data?.message?.isEdit ? "You updated the Event" : "You created a new Event"}
                </span>
              <ChatRightInfo userDetails = {fromcaller_details} timeStamp = {timestamp} message={data}></ChatRightInfo>
              <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
          <ChatHoverOption className='hoverList hoverListright' data={data} highlightHover={handlehighlightHover}/></div>
            </div>
            <Tooltip mouseEnterDelay={0.5} placement="topRight" title={htimestamp}
              className='cusTooltip' overlayClassName='customTooltip'>
              <div className={styles.chatTime}>{htimestamp}</div></Tooltip>
              
          </div>
          <ChatLike className='likeRight' placement="topRight"
                tooltipTitle={data?.likeduserdetails} message={data}/>
        </div>
      </div>)}
      

      

        {/* <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
        <div className={styles.chatRightMessages}>
          <div className={styles.chatRight}>
            <div className={styles.chatContent}>
              <p className={styles.eventsChatContent}>You created a new Task</p>
              <ChatEventsInner />
            </div>
            <Tooltip placement="topRight" title='Today at 12:13 PM'
              className='cusTooltip' overlayClassName='customTooltip'>
              <div className={styles.chatTime}>12:13</div></Tooltip>
          </div>
        </div>
        <URCheckBox className="chatSelectRight" />
        <div className={styles.hoverOptions}><ChatHoverOption className='hoverList hoverListright' /></div>
      </div> */}
      </>
    );
  } catch (e) {
    return <p style={{ color: "red" }}>Something went wrong</p>;
  }
}
